import { RouteConfig } from '@abaco/web-common/src/app';

const routes: RouteConfig[] = [
    {
        name: "import-company-base",
        path: "/import-company-base",
        component: () => import("./components/ImportCompanyBaseTileContainer.vue"),
    },
    {
        name: "uma-dealer-management",
        path: "/uma-dealer-management",
        component: () => import("./components/UmaIframeContainer.vue"),
        props: {type: "uma-dealer-management"}
    },
    {
        name: "uma-delivery-management",
        path: "/uma-delivery-management",
        component: () => import("./components/UmaIframeContainer.vue"),
        props: {type: "uma-delivery-management"}
    },
    {
        name: "uma-withdrawal-insert",
        path: "/uma-withdrawal-insert",
        component: () => import("./components/UmaIframeContainer.vue"),
        props: {type: "uma-withdrawal-insert"}
    },
    {
        name: "profitosan",
        path: "/profitosan",
        component: () => import("./components/ProfitosanTileContainer.vue"),
        meta: { navbarItems: ["farm-select-nav-bar-item"] }
    },
    {
        name: "siti-reports-access",
        path: "/siti-reports-access",
        component: () => import("./components/ReportsTileContainer.vue"),
        meta: { navbarItems: [] }
    },
];

export default routes;
